<template>
  <div>
    <div class="ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-2 ts-relative ts-text-blue-700">
      <div class="d-flex justify-content-between">
        <div>
          <b>{{ $t('payslipTemplate.userVariable') }}</b>
          <i class="fa fa-spinner spin ml-2" v-if="readyFetchVariable"></i>
        </div>
        <div>
          <a href="#" @click.prevent="collapse = collapse ? false : true">
            <i class="fas fa-chevron-down" v-if="!collapse"></i>
            <i class="fas fa-chevron-up" v-else></i>
          </a>
        </div>
      </div>
    </div>
    <div id="varibleTable" v-show="!collapse">
      <table class="table table-hover ui-table" v-if="!readyFetchVariable">
        <thead>
          <tr>
            <th style="width:19%">{{ $t('payslipTemplate.variableName') }}</th>
            <th>{{ $t('payslipTemplate.description') }}</th>
            <th style="width:19%">{{ $t('payslipTemplate.type') }}</th>
          </tr>
          <tr>
            <th>
              <input
                v-model="filters.variableName"
                type="text"
                class="form-control"
                :placeholder="$t('payslipTemplate.filterVariableName')"
              />
            </th>
            <th>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('payslipTemplate.filterDescription')"
                v-model="filters.description"
              />
            </th>
            <th>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('payslipTemplate.filterType')"
                v-model="filters.dataType"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(variable, index) in filterResults" :key="index" @dblclick="addFieldTemplate(variable)">
            <td>{{ variable.sv_name }}</td>
            <td>{{ variable.display_name }}</td>
            <td>{{ variable.data_type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-2 ts-relative ts-text-blue-700 ts-my-1">
      <b>{{ $t('payslipTemplate.pageTitle') }}</b>
    </div>
    <div
      id="tablePayrollTemplate"
      :style="{ height: collapse ? '72vh' : '30vh', 'max-height': collapse ? '77vh' : '32vh' }"
    >
      <table class="table table-hover ui-table">
        <thead>
          <tr>
            <th>{{ $t('payslipTemplate.orderId') }}</th>
            <th>{{ $t('payslipTemplate.displayName') }}</th>
            <th>{{ $t('payslipTemplate.block') }}</th>
            <th>{{ $t('payslipTemplate.subBlock') }}</th>
            <th>{{ $t('payslipTemplate.display') }}</th>
            <th style="width:7%;" class="text-center">{{ $t('payslipTemplate.action') }}</th>
          </tr>
        </thead>
        <draggable v-model="template_detail" tag="tbody">
          <tr v-for="(item, index) in template_detail" :key="index">
            <td valign="middle">
              <p class="mt-2">{{ item.variable_name }}</p>
            </td>
            <td style="width:40%">
              <input type="text" class="form-control only-border-bottom" v-model="item.display_name" />
            </td>
            <td>
              <select v-model="item.block_id" class="form-control only-border-bottom" @change="mainBlockChange(item)">
                <option value></option>
                <option v-for="(block, index) in blocks" :key="index" :value="block.block_id">{{ block.block }}</option>
              </select>
            </td>
            <td style="width:25%">
              <select v-model="item.sub_block_id" class="form-control only-border-bottom">
                <option value></option>
                <option
                  v-for="(sub, index) in subBlocks.filter(s => s.block_id == item.block_id)"
                  :key="index"
                  :value="sub.sub_block_id"
                  >{{ sub.sub_block }}</option
                >
              </select>
            </td>
            <td>
              <select v-model="item.display_side" class="form-control only-border-bottom">
                <option value></option>
                <option value="R">Right</option>
                <option value="L">Left</option>
              </select>
            </td>
            <td class="text-center" valign="middle">
              <a href="#" class="mt-2" @click="removeRow(item)" v-tooltip="$t('payslipTemplate.remove')">
                <i class="fas fa-minus-circle mt-2 text-danger"></i>
              </a>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'varible-list',
  props: ['value'],
  components: {
    draggable
  },
  data() {
    return {
      template_detail: [],
      collapse: false,
      readyFetchVariable: false,
      filters: {
        variableName: '',
        description: '',
        dataType: ''
      }
    }
  },
  computed: {
    ...mapState('hr/payslipTemplate', ['blocks', 'subBlocks']),
    filterResults() {
      return this.$store.state.hr.payslipTemplate.userVariables
        .filter(v => v.sv_name.toLowerCase().indexOf(this.filters.variableName.toLowerCase()) != -1)
        .filter(v => v.display_name.toLowerCase().indexOf(this.filters.description.toLowerCase()) != -1)
        .filter(v => v.data_type.toLowerCase().indexOf(this.filters.dataType.toLowerCase()) != -1)
    }
  },
  created() {
    this.fetchVariable()
    this.getBlock()
    this.template_detail = this.value
  },
  methods: {
    ...mapActions('hr/payslipTemplate', ['getBlock']),
    fetchVariable() {
      this.readyFetchVariable = true
      this.$store
        .dispatch('hr/payslipTemplate/variable')
        .then(response => {
          this.readyFetchVariable = false
        })
        .catch(error => {
          this.readyFetchVariable = false
          this.$toasted.error(error.message)
        })
    },
    addFieldTemplate(field) {
      this.template_detail.push({
        variable_name: field.sv_name,
        display_name: field.display_name,
        block_id: '',
        sub_block_id: '',
        display_side: ''
      })

      this.$toasted.info('The field name : ' + field.display_name + ' added.')
    },
    removeRow(item) {
      this.template_detail.splice(this.template_detail.indexOf(item), 1)
      this.$toasted.info('The item name : ' + item.display_name + ' removed.')
    },
    mainBlockChange(row) {
      if (!row.block_id) {
        row.sub_block_id = ''
      }
    }
  },
  watch: {
    template_detail: function(value) {
      this.$emit('sort', value)
    }
  }
}
</script>

<style lang="css" scoped>
#varibleTable {
  max-height: 300px;
  height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

#tablePayrollTemplate {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}
#varibleTable .table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
}
#tablePayrollTemplate .table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: grab;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
